module.exports = __webpack_public_path__ + "img/video-play.efb9c81a.png";